import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import PageContent from 'components/Generic/PageContent';
import { TableFilterProvider } from 'tableFilterContext';
import { Routes } from 'routes';
import { AppContext } from 'context';
import { UserRole } from 'types';
import ClientList from './ClientList';

const ClientListPage: React.FC = () => {
  const { t } = useTranslation();
  const context = useContext(AppContext);
  const userCanAddUser = context.hasLeastOneAdminRole() || context.getRoles?.()?.includes(UserRole.ROLE_MANAGER);

  return (
    <PageContent
      title={t('clients.referentielClients')}
      actionButtonLink={userCanAddUser ? Routes.ClientCreate : undefined}
      noPadding
    >
      <TableFilterProvider>
        <ClientList />
      </TableFilterProvider>
    </PageContent>
  );
};
export default ClientListPage;
